module.exports = __webpack_public_path__ + "img/italic.16b7736b.svg";